import React from "react";
import "./Marquee.scss";

export default function Marquee({ items = [] }) {
  const content = [...items, ...items, ...items]; // чтобы цикл был длинным
  return (
    <div className="marquee gold-shimmer">
      <div className="marquee__track">
        {content.map((t, i) => <span key={i} className="marquee__item">{t}</span>)}
      </div>
    </div>
  );
}
